module.exports = __webpack_public_path__ + "static/media/originusd.f93479e0.png";